import { ReactNode } from 'react'

import { Icon, Tooltip } from 'govwell-ui'
import { ViewColumnTemplateFragment, ViewColumnType } from 'types/graphql'

type TableViewColumnOverride = {
  renderHeader?: (args: {
    columnTemplate: ViewColumnTemplateFragment
    defaultHeader: ReactNode
  }) => ReactNode
}

export const TableViewColumnOverrides: Partial<Record<ViewColumnType, TableViewColumnOverride>> = {
  SettlementEstimatedBankDepositDate: {
    renderHeader: ({ defaultHeader }: { defaultHeader: ReactNode }) => {
      return (
        <>
          {defaultHeader}
          <Tooltip content="This is an estimated date based on processing times and may vary.">
            <div>
              <Icon.FaQuestionCircle />
            </div>
          </Tooltip>
        </>
      )
    },
  },
}
